import { useState, useCallback, useEffect } from 'react';
import { processStreamingContent } from '../../utils/artifactParser';

export const useArtifactState = (selectedChat, messages) => {
  const [currentArtifact, setCurrentArtifact] = useState(null);
  const [isArtifactExpanded, setIsArtifactExpanded] = useState(false);

  // Artifact handlers
  const handleArtifactOpen = useCallback((artifact, isMobile) => {
    console.log('Opening artifact:', artifact.title, artifact.type);
    setCurrentArtifact(artifact);
    
    // Close sidebar when artifact opens (except on mobile)
    if (!isMobile) {
      // This would need to be passed in as a callback
      // setIsSidebarOpen(false);
    }
  }, []);

  const handleArtifactClose = useCallback(() => {
    console.log('Closing artifact');
    setCurrentArtifact(null);
    setIsArtifactExpanded(false);
  }, []);

  const handleToggleArtifactExpanded = useCallback(() => {
    setIsArtifactExpanded(!isArtifactExpanded);
  }, [isArtifactExpanded]);

  // Auto-close artifact when switching chats or creating new chat
  useEffect(() => {
    handleArtifactClose();
  }, [selectedChat, handleArtifactClose]);

  // Update open artifact with live streaming content and auto-replace with new artifacts
  useEffect(() => {
    if (!selectedChat) return;

    const currentMessages = messages[selectedChat.id] || [];
    const lastAssistantMessage = currentMessages
      .filter(msg => msg.role === 'assistant')
      .pop();

    if (lastAssistantMessage && lastAssistantMessage.text && lastAssistantMessage.streaming) {
      const { hasArtifact, currentArtifact: newArtifact } = processStreamingContent(lastAssistantMessage.text);
      
      if (hasArtifact && newArtifact && newArtifact.isStreaming) {
        // If there's already an artifact open
        if (currentArtifact) {
          // If it's the same artifact (same type and title), update it
          if (newArtifact.type === currentArtifact.type && 
              newArtifact.title === currentArtifact.title) {
            console.log('Live updating artifact:', newArtifact.title);
            setCurrentArtifact(newArtifact);
          } 
          // If it's a different artifact, auto-replace with the new one
          else {
            console.log('Auto-replacing artifact:', currentArtifact.title, '->', newArtifact.title);
            setCurrentArtifact(newArtifact);
          }
        }
        // If no artifact is currently open, this could trigger auto-opening in the future
        // For now, we just detect new artifacts but don't auto-open them
      }
    }
  }, [messages, currentArtifact, selectedChat]);

  return {
    currentArtifact,
    isArtifactExpanded,
    handleArtifactOpen,
    handleArtifactClose,
    handleToggleArtifactExpanded
  };
};